export enum DiscountOption {
    ToPatient = 1,
    ToPayer = 2
}
